module.exports = __webpack_public_path__ + "assets/folder-tree.088174cd.svg";